import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetFundraisingRecalculation = (payload, options = {}) => {
  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 5, // 5 minutes stale
    queryKey: [QUERY_KEYS.fundraising.recalculation, payload],
    queryFn: () =>
      fundraisingService.fundraisingRecalculation(payload, { company_id: payload.company_id }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
